import ProductService from "../../Api/ProductService";
import {GET_PPRODUCTS, SET_CAT_PRODUCT_FILTER, SET_PPRODUCT_DATA} from "./types";

import ProductData from "../../data/ProductData";
const defaultProductData = ProductData.getDefaultProductData();


export const setCatProductAction = (id) => async (dispatch) => {
    dispatch({type: SET_CAT_PRODUCT_FILTER, payload: id})
};

export const getProductsAction = (filters) => async (dispatch) => {
    try {
        const data = await ProductService.getAll(filters);
        dispatch({type: GET_PPRODUCTS, payload: data})
    } catch (err) {
        //dispatch(getError(err.response.data));
        console.log(err)
    }
};

export const setProductDataAction = (id) => async (dispatch) => {

    try {
        if (id) {
            const data = await ProductService.getOne(id);
            dispatch({type: SET_PPRODUCT_DATA, payload: data});
        } else {
            dispatch({type: SET_PPRODUCT_DATA, payload: defaultProductData});
        }
    } catch (err) {
        //dispatch(getError(err.response.data));
        console.log(err)
    }
};



